module.exports = __webpack_public_path__ + "static/media/left.7fc61ac8.svg";